import { render, staticRenderFns } from "./user-detail-modal.vue?vue&type=template&id=3e7ef618"
import script from "./user-detail-modal.vue?vue&type=script&lang=js"
export * from "./user-detail-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports